import { Record } from 'immutable';

export default class BookingPaymentItemRecord extends Record({
  id: undefined,
  article: undefined,
  attested: undefined,
  attestedDates: undefined,
  booked: undefined,
  bookedDates: undefined,
  booking: undefined,
  createdAt: undefined,
  description: undefined,
  included: undefined, // FE Usage
  internalAbsentReason: undefined, // FE Usage
  internalDates: undefined, // FE Usage
  internalPrice: undefined, // FE Usage
  links: undefined,
  resource: undefined,
  salaryCode: undefined,
  totalAttestedPrice: undefined,
  totalBookedPrice: undefined,
}) {
}
